export const collectTransportMode = (name, type, data, memberNumber) => {
  if (type === "TEAM_LEADER") {
    return {
      type: name === "TRANSPORT" && "TEAM_LEADER_TRANSPORT",
      payload: data
    }
  } else {
    return {
      type: name === "TRANSPORT" && `TEAM_MEMBER_${memberNumber}_TRANSPORT`,
      payload: data,
      index: memberNumber
    }
  }
}
